import { Selector } from 'reselect'

import {
  networkGroup,
} from './utils'

import {
  IForm_File,
} from '@kaidam/fc-shared/src/types/schema/form'

import {
  RootState,
} from '../../types/store'

export const list: Selector<RootState, IForm_File[]> = state => 
  state.filestore.list

export const network = networkGroup('filestore', [
  'list',
])

export default {
  list,
  network,
}
